import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import toast from "react-hot-toast";
import { V_URL } from "../../../../BaseUrl";

export const downloadAdminQuatation = createAsyncThunk(
    "/admin/download-admin-quotation",
    async (id) => {
        try {
            const myurl = `${V_URL}/believe/download-quotation/${id}`;

            const response = await axios({
                method: "get",
                url: myurl,
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("VA_TOKEN"),
                },
            });

            const data = response.data;

            if (data.success === true) {
                return data;
            } else {
                throw new Error(data);
            }
        } catch (error) {
            console.log(error, "error");
            toast.error(error.response.data.message);
            return error;
        }
    }
);

const downloadAdminQuatationSlice = createSlice({
    name: "downloadAdminQuatation",
    initialState: {
        user: null,
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(downloadAdminQuatation.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(downloadAdminQuatation.fulfilled, (state, action) => {
                state.user = action.payload;
                state.loading = false;
                state.error = null;
            })
            .addCase(downloadAdminQuatation.rejected, (state, action) => {
                state.user = null;
                state.loading = false;
                state.error = action.error.message;
            });
    },
});

export default downloadAdminQuatationSlice.reducer;
